import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { FieldArray, Fields, FormSection } from 'redux-form';
import { CAREER_MONTH_DEFAULT_VALUE, CAREER_YEAR_DEFAULT_VALUE, } from '../../../../define/consts/profile';
import { propArrayShape, propBool, propStr, } from '../../../../helpers/custom-prop-types';
import { consultantValidate } from '../../../../validate/custom/profile';
import ArrayFieldsAndLabel from '../../../Ui/Profile/Hook/ArrayFieldsAndLabel';
import CareerRowParts from '../Parts/Career/CareerRowParts';
import ProjectCareerRowParts from '../Parts/Career/ProjectCareerRowParts';
const YourSectionCareer = (props) => {
    const { form, largeTasks, middleTasks, submitFailed } = props;
    const projectCareerOptions = useMemo(() => largeTasks.map((largeTask) => ({
        label: largeTask.name,
        options: middleTasks
            .filter(({ largeTaskId }) => largeTask.id === largeTaskId)
            .map((v) => ({
            label: v.name,
            value: v.id,
        })),
    })), [largeTasks, middleTasks]);
    const { career, projectCareer } = useMemo(() => ({
        career: {
            addObject: {
                month: CAREER_MONTH_DEFAULT_VALUE,
                year: CAREER_YEAR_DEFAULT_VALUE,
            },
            names: ['year', 'month', 'title', 'content'],
            validate: consultantValidate.career.normal,
        },
        projectCareer: {
            addObject: {},
            names: ['title', 'middleTasks', 'content'],
            validate: consultantValidate.projectCareer.normal,
        },
    }), []);
    return (_jsxs(_Fragment, { children: [_jsx(FieldArray, { addObject: career.addObject, component: ArrayFieldsAndLabel, form: form, heading: '学歴／職歴', isRequired: false, isSubmitFailed: submitFailed, name: 'careers', render: (renderProps) => (_jsx(FormSection, Object.assign({ name: renderProps.field }, { children: _jsx(Fields, { component: CareerRowParts, index: renderProps.index, names: career.names, onClickDelete: renderProps.onClickDelete, validate: career.validate }) }), renderProps.field)), validate: consultantValidate.career.normal.array }), _jsx(FieldArray, { addObject: projectCareer.addObject, component: ArrayFieldsAndLabel, description: '（企業の閲覧率高）', descriptionClassName: '', form: form, heading: 'プロジェクト実績', isRequired: false, isSubmitFailed: submitFailed, name: 'projectCareers', render: (renderProps) => (_jsx(FormSection, Object.assign({ name: renderProps.field }, { children: _jsx(Fields, { component: ProjectCareerRowParts, index: renderProps.index, middleTaskOptions: projectCareerOptions, names: projectCareer.names, onClickDelete: renderProps.onClickDelete, validate: projectCareer.validate }) }), renderProps.field)), subDescription: '＊企業が面談先を選定する際に参考にする情報ですので、なるべく多く、具体的に記載を頂くことをお勧めいたします', validate: consultantValidate.projectCareer.normal.array })] }));
};
YourSectionCareer.propTypes = {
    form: propStr().isRequired,
    largeTasks: propArrayShape().isRequired,
    middleTasks: propArrayShape().isRequired,
    submitFailed: propBool().isRequired,
};
export default YourSectionCareer;
